import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import Button from '@material-ui/core/Button';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import './noReply interest.css'
import { message, TreeSelect, DatePicker, ConfigProvider } from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment'
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
import 'moment/locale/ar';
import PaginationButtons from '../../component/pagenation/pagenation';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
const { RangePicker } = DatePicker;
let headers = [
  { label: "#", key: "id" },
  { label: "الاسم", key: "fullname" },
  { label: "رقم الهاتف", key: "phone" },
  { label: "الدوله", key: "country" },
  { label: "الشركه", key: "project" },
  { label: "الحاله", key: "status" },
  { label: "المدينه", key: "city" },
  { label: "النوع", key: "subCategory" },
  { label: "التاريخ", key: "date" },
];

let csvData = [

];
class interests extends React.Component {

  state = {
    interests: [],
    interests2: [],
    csvData: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    collapsed: false,
    count: 0,
    showFilter: false,
    isReady: false,
    buildCsv: false,
    startDate: null,
    endDate: null,
    updatedAtStartDate: null,
    updatedAtEndDate: null,
    search: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.search ? this.props.location.state.searchData.search : null : null : null,
    project: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.project ? this.props.location.state.searchData.project : null : null : null,
    city: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.city ? this.props.location.state.searchData.city : null : null : null,
    area: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.area ? this.props.location.state.searchData.area : null : null : null,
    subCategory: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.subCategory ? this.props.location.state.searchData.subCategory : null : null : null,
    category: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.category ? this.props.location.state.searchData.category : null : null : null,
    country: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.country ? this.props.location.state.searchData.country : null : null : null,
    status: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.status ? this.props.location.state.searchData.status : null : null : null,
    clientType: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.clientType ? this.props.location.state.searchData.clientType : null : null : null,
    clientStatus: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.clientStatus ? this.props.location.state.searchData.clientStatus : null : null : null,
    followUpStatus: this.props.location.state ? this.props.location.state.searchData ? this.props.location.state.searchData.followUpStatus ? this.props.location.state.searchData.followUpStatus : null : null : null,
    projects: [],
    countries: [],
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
    users: [],
    assignedToId: null,
    assignedTo: this.props.location.state ? this.props.location.state.data ? this.props.location.state.data.assignedTo : null : null,

    modalForAssigned: false,
    selectedRow: null,
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    this.getUserWithoutPagenation()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    let pageNum = this.state.page
    if (sessionStorage.getItem('pageName') === "INTERESTS") {
      pageNum = sessionStorage.getItem('pageNum');
      this.setState({ page: pageNum })
    }
    this.getInterests(pageNum, false)
    this.getProjects()
    this.getCategory()
    this.getCountries()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ countries: response.data.data })
      })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/${country}/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log(response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log("ALL cities ERROR")
        console.log(error.response)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  getInterests = (page, refresh) => {
    this.setState({ loading: true })
    let url = `${BASE_END_POINT}interests?page=${page}&inNoReplyList=true`
    let { assignedTo, city, area, subCategory, status, search, startDate, endDate, updatedAtStartDate, updatedAtEndDate, project, clientType, clientStatus, followUpStatus } = this.state
    if (refresh !== true) {
      let keysToFilter = { assignedTo, status, search, startDate, endDate, updatedAtStartDate, updatedAtEndDate, project, city, area, subCategory, clientType, clientStatus, followUpStatus }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
      //search data 
      let searchData = Object.fromEntries(
        Object.entries({
          assignedTo, city, area, subCategory, status, search, project,
          clientType, clientStatus, followUpStatus
        }).filter(([_, value]) => value !== "" && value != null)
      );
      sessionStorage.setItem('searchData', JSON.stringify(searchData));

    } else {
      this.setState({ loading: false, assignedTo: null, status: null, search: null, city: null, area: null, subCategory: null, updatedAtStartDate, updatedAtEndDate, startDate: null, endDate: null, clientType: null, clientStatus: null, followUpStatus: null })
      sessionStorage.setItem('searchData', JSON.stringify({}));
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("interests   ", response.data)
        let data = response.data.data.map(item => [
          item.id,
          item.fullname ? item.fullname : '',
          item.phone ? item.phone : '',
          item.project ? item.project.name : item.company ? item.company : '--',
          item.assignedTo ? item.assignedTo.fullname : 'لايوجد',
          item.status === "PENDING" ? { type: 'tag', value: allStrings.pending } : item.status === "CONTACT-PHASE" ? { type: 'tag', value: allStrings.contactPhase } : item.status === "VISITING-PHASE" ? { type: 'tag', value: allStrings.visitingPhase } : item.status === "CLOSED" ? { type: 'tag', value: allStrings.closed } : { type: 'tag', value: allStrings.contactDone },
          // item.subCategory?item.subCategory.categoryName:'--',
          item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : "",
          "action"])
        console.log("DATA   ", data)
        this.setState({
          loading: false,
          refresh: false,
          count: response.data.totalCount,
          interests: response.data.data,
          interests2: data,
          page: response.data.page,
          pages: response.data.pageCount,
        })
        sessionStorage.setItem('pageNum', page);
        sessionStorage.setItem('pageName', "INTERESTS");

      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getInterestsWithoutPagenation = (refresh) => {
    let url = `${BASE_END_POINT}interests/withoutPagenation/get?inNoReplyList=true`
    let { assignedTo, city, area, subCategory, status, search, startDate, endDate, updatedAtStartDate, updatedAtEndDate, project, clientType, clientStatus, followUpStatus } = this.state
    if (refresh !== true) {
      let keysToFilter = { assignedTo, status, search, startDate, endDate, updatedAtStartDate, updatedAtEndDate, project, city, area, subCategory, clientType, clientStatus, followUpStatus }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });

    } else {
      this.setState({ loading: false, assignedTo: null, status: null, search: null, city: null, area: null, subCategory: null, updatedAtStartDate: null, updatedAtEndDate: null, startDate: null, endDate: null, clientType: null, clientStatus: null, followUpStatus: null })
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("interests   ", response.data)
        csvData = response.data.data.map(item => {
          return {
            ...{ id: item.id },
            ...{ fullname: item.fullname ? item.fullname : '' },
            ...{ phone: item.phone ? "\t" + item.phone : '' },
            ...{ project: item.project ? item.project : '' },
            ...{ status: status === "PENDING" ? allStrings.pending : item.status === "CONTACT-PHASE" ? allStrings.contactPhase : item.status === "VISITING-PHASE" ? allStrings.visitingPhase : item.status === "CLOSED" ? allStrings.closed : allStrings.contactDone },
            ...{ subCategory: item.subCategory ? item.subCategory.categoryName : '' },
            ...{ city: item.city ? item.city.cityName : '' },
            ...{ date: moment(item.createdAt).format("dddd D MMMM YYYY hh:mm A") },
          };
        });
        console.log(csvData)
        this.setState({ csvData: csvData, isReady: true })

      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
      })
  }
  delete = (id) => {
    console.log("ID   ", id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}interests/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("Row DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getInterests(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ users: response.data.data })
    })
      .catch(error => {
        console.log("ALL users ERROR")
        console.log(error.response)
      })
  }
  assignedTo = () => {
    const { assignedToId } = this.state
    const idsArray = this.state.selectedRow.map(item => item.id);
    console.log("idsArray", idsArray)
    if (assignedToId != null) {
      let l = message.loading('Wait..', 2.5)
      axios.put(`${BASE_END_POINT}interests/${idsArray}/assignTo/${assignedToId}`, {
        ids: idsArray
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("interest assigned To")
          l.then(() => message.success(allStrings.done, 2.5))
          this.getInterests(this.state.page, false)
          this.setState({ modalForAssigned: false, assignedToId: null, selectedRow: null })
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  submitHandlerAssigned = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.assignedTo()
  };
  toggleForAssigned = (rowData) => {
    console.log("rowData", rowData)
    this.setState({
      selectedRow: Array.isArray(rowData) ? rowData : [rowData],
      modalForAssigned: !this.state.modalForAssigned,
    });
  };
  modalForAssigned = () => (
    <MDBModal isOpen={this.state.modalForAssigned} toggle={this.toggleForAssigned} size="lg">
      <MDBModalHeader toggle={this.toggleForAssigned} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerAssigned}
                noValidate
              >
                <div className="grey-text">
                  {this.state.selectedRow && this.state.selectedRow.length > 0 ? (
                    <div>
                      <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>
                        {this.state.selectedRow.map(row => `#${row ? row.id : ""}`).join(' - ')}
                      </label>
                    </div>
                  ) : null}

                  <MDBRow>
                    <MDBCol md="12">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.employee}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ assignedToId: value });
                        }}

                      >
                        {this.state.users.map(val => (
                          <TreeNode value={val.id} title={val.fullname} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForAssigned}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.send}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  onChange = (date, dateString) => {
    console.log(dateString);
    if (this.props.isRTL) {
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    } else {
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    }
  }
  onChangeUpdateDate = (date, dateString) => {
    console.log(dateString);
    if (this.props.isRTL) {
      this.setState({
        updatedAtStartDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        updatedAtEndDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    } else {
      this.setState({
        updatedAtStartDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        updatedAtEndDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    }
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('NO-REPLY-INTERESTS')) return <Redirect to='/Home' />
    return (
      <MDBContainer>
        <MDBRow>
          {this.modalForAssigned()}
          <MDBCol md="12">
            <div className="screenTable">

              <Table
                title={allStrings.noReplyInterests}
                icon='contact_phone'

                settings={
                  <div>
                    <i class="fab fa-searchengin searchIcon" onClick={() => this.setState({ showFilter: !this.state.showFilter })}></i>
                    <span
                      style={{ zIndex: '1', position: 'relative', padding: '4px', color: '#659FF1', fontSize: '25px', borderRadius: '50%', top: '4px', cursor: 'pointer' }}
                      onClick={() => { this.getInterests(1, true); this.setState({ buildCsv: false }) }}
                      class="material-icons">
                      replay
                    </span>
                    {!this.state.buildCsv &&
                      <img crossorigin="anonymous" alt="" onClick={() => { this.setState({ buildCsv: true }); this.getInterestsWithoutPagenation() }}
                        style={{ padding: '0px', position: 'relative', top: '-6px', marginLeft: '5px', cursor: 'pointer' }}
                        src={require('../../assets/images/buildCsv.png')} width="26"></img>
                    }{!this.state.isReady && this.state.buildCsv &&
                      <img crossorigin="anonymous" alt=""
                        style={{ padding: '0px', position: 'relative', top: '-5px', marginLeft: '-15px' }}
                        src={require('../../assets/images/loading.gif')} width="70"></img>
                    }{this.state.isReady && this.state.buildCsv && !this.props.currentUser.user.isEmployee &&
                      <CSVLink
                        data={this.state.csvData}
                        headers={headers}
                        filename={"interests.csv"}
                        style={{ padding: '10px', position: 'relative', top: '-5px' }}
                      >
                        <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                      </CSVLink>
                    }
                  </div>

                }
                filter={
                  <div>
                    <div className={this.state.showFilter ? 'showClass' : 'hideClass'}>
                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientType}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.clientType}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.clientType}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ clientType: value });
                            }}

                          >
                            <TreeNode value="RENT" title={allStrings.rent} key="RENT" />
                            <TreeNode value="HOUSING" title={allStrings.housing} key="HOUSING" />
                            <TreeNode value="INVESTMENT" title={allStrings.investment} key="INVESTMENT" />
                            <TreeNode value="OFF-PLAN-SALE" title={allStrings.offPlanSale} key="OFF-PLAN-SALE" />

                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.clientStatus}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.clientStatus}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.clientStatus}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ clientStatus: value });
                            }}

                          >
                            <TreeNode value="INTERESTED-CLIENT" title={allStrings.interested} key="INTERESTED-CLIENT" />
                            <TreeNode value="FOLLOW-UP" title={allStrings.followUp} key="FOLLOW-UP" />
                            <TreeNode value="NO-REPLY" title={allStrings.noReply} key="NO-REPLY" />
                            <TreeNode value="NOT-INTERESTED" title={allStrings.notInterested} key="NOT-INTERESTED" />
                            <TreeNode value="PURCHASED" title={allStrings.purchased} key="PURCHASED" />

                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.followUpStatus}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.followUpStatus}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.followUpStatus}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ followUpStatus: value });
                            }}

                          >
                            <TreeNode value="DIFFERENT-REQUEST" title={allStrings.differentRequest} key="DIFFERENT-REQUEST" />
                            <TreeNode value="NOT-INTERESTED" title={allStrings.notInterested} key="NOT-INTERESTED" />
                            <TreeNode value="ANOTHER-CALL-SCHEDULED" title={allStrings.callbackScheduled} key="ANOTHER-CALL-SCHEDULED" />
                            <TreeNode value="NO-REPLY" title={allStrings.noReply} key="NO-REPLY" />
                            <TreeNode value="WHATSAPP-CONNTACT" title={allStrings.whatsappConnect} key="WHATSAPP-CONNTACT" />
                            <TreeNode value="OTHER" title={allStrings.other} key="OTHER" />

                          </TreeSelect>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.area}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.area}
                            value={this.state.area}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ area: value });
                            }}

                          >
                            {this.state.areas.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.areaName_ar : val.areaName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.city}
                            value={this.state.city}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ city: value });
                              this.getAreas(value)
                            }}

                          >
                            {this.state.cities.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.country}
                            value={this.state.country}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ country: value });
                              this.getCities(value)
                            }}

                          >
                            {this.state.countries.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.project}
                            value={this.state.project}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ project: value });

                            }}
                          >
                            {this.state.projects.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>

                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.subCategory}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.subCategory}
                            value={this.state.subCategory}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ subCategory: value });
                            }}

                          >
                            {this.state.subCategories.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.category}
                            value={this.state.category}
                            showCheckedStrategy={SHOW_PARENT}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ category: value });
                              this.getSubCategory(value)
                            }}

                          >
                            {this.state.categories.map(val => (
                              <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>

                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.updateDate}</label>
                          <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                            <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChangeUpdateDate} />
                          </ConfigProvider>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.employee}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ assignedTo: value });
                            }}

                          >
                            {this.state.users.map(val => (
                              <TreeNode value={val.id} title={val.fullname} key={val.id} />
                            ))}
                          </TreeSelect>
                        </MDBCol>


                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                          <TreeSelect virtual={false}
                            showSearch={true}
                            value={this.state.status}
                            style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                            treeCheckable={false}
                            treeNodeFilterProp="title"
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.status}
                            onChange={(value) => {
                              console.log(value)
                              this.setState({ status: value });
                            }}

                          >
                            <TreeNode value="PENDING" title={allStrings.pending} key="PENDING" />
                            <TreeNode value="CONTACT-PHASE" title={allStrings.contactPhase} key="CONTACT-PHASE" />
                            <TreeNode value="VISITING-PHASE" title={allStrings.visitingPhase} key="VISITING-PHASE" />
                            <TreeNode value="CLOSED" title={allStrings.closed} key="CLOSED" />
                            <TreeNode value="DONE" title={allStrings.contactDone} key="DONE" />

                          </TreeSelect>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12"></MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <div class="md-form">
                            <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.Search}</label>
                            <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', fontWeight: '300' }} type="text" id="form605" class="form-control"
                              placeholder={allStrings.Search}
                              onChange={(e) => {
                                this.setState({ search: e.target.value })
                              }} />
                          </div>
                        </MDBCol>
                        <MDBCol xl="4" lg="4" md="4" sm="12">
                          <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                          <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                            <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChange} />
                          </ConfigProvider>
                        </MDBCol>

                      </MDBRow>
                      <MDBRow>
                        <MDBCol xl="12" lg="12" md="12" sm="12">
                          <Button style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', width: '100%', margin: '32px auto' }}
                            onClick={() => { this.getInterests(1); this.setState({ buildCsv: false }) }}><SearchOutlined /> {allStrings.Search}</Button>

                        </MDBCol>
                      </MDBRow>

                    </div>
                  </div>
                }
                data={this.state.interests}
                data2={this.state.interests2}
                tableColumns={["#", allStrings.fullname, allStrings.phone, allStrings.project, allStrings.employee, allStrings.status, allStrings.date, allStrings.action]} loading={this.state.loading}
                deleteItem={(id) => { this.delete(id) }}
                path='/interestInfo'
                actionIndex={8}
                enableEdit={false}
                enableAssigne={this.props.currentUser.user.type === "ADMIN" ? true : this.props.currentUser.user.isEmployee == false ? true : false}
                assignedToModal={(rowData) => this.toggleForAssigned(rowData)}
                dataCount={this.state.count}
                noDelete={this.props.currentUser.user.type === "ADMIN" ? false : true}
              />
              <PaginationButtons
                page={this.state.page}
                pages={this.state.pages}
                labels={allStrings}
                onPageChange={(newPage) => {
                  this.getInterests(newPage);
                  this.setState({ page: newPage });
                }}
              />

            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDACCEPTEDatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDACCEPTEDatchToProps)(interests)
);

